export default __webpack_public_path__ + "static/media/clients.05f3b1d3.svg";